export default "__VITE_PUBLIC_ASSET__a223f920__"